<!-- /* [MATCH-DENY-P-POP] 거절서 작성(개인) */ -->

<template>
  <div v-if="matchPeople">
    <BasicModal
      :isShowModal="isModal"
      @close-modal="$store.commit('directMatching/setHideModalPopup')"
      title="거절서 작성f"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <CorpInfoCard
          v-if="matchPeople.roleName == $role.CORP"
          :data="matchPeople"
        ></CorpInfoCard>
        <UserInfoCard
          v-else-if="matchPeople.roleName == $role.USER"
          :data="matchPeople"
        ></UserInfoCard>

        <section>
          <h3 class="matchingHeadLine">거절서 작성</h3>
          <ValidationObserver
            tag="form"
            @submit.prevent="onClickSubmitForm"
            class="aRow5"
            id="formMatchDenyPPopup"
          >
            <div
              style="margin-bottom: 50px; gap: 16px; display: flex; flex-direction: column; padding-top: 24px;"
            >
              <ValidationProvider name="연락 담당자 이름" rules="required">
                <b-form-checkbox
                  v-model="form.responseReason"
                  value="매칭이 어려울 것 같습니다."
                  unchecked-value="not_accepted"
                  class="basic-check-box"
                >
                  매칭이 어려울 것 같습니다.
                </b-form-checkbox>
              </ValidationProvider>
              <ValidationProvider name="연락 담당자 이름" rules="required">
                <b-form-checkbox
                  v-model="form.responseReason"
                  value="당장 매칭이 어려우나 향후에 조율이 가능할 것 같습니다."
                  unchecked-value="not_accepted"
                  class="basic-check-box"
                >
                  당장 매칭이 어려우나 향후에 조율이 가능할 것 같습니다.
                </b-form-checkbox>
              </ValidationProvider>
              <ValidationProvider name="연락 담당자 이름" rules="required">
                <b-form-checkbox
                  v-model="form.responseReason"
                  value="기타 사유로 인한 거절"
                  unchecked-value="not_accepted"
                  class="basic-check-box"
                >
                  기타 사유로 인한 거절
                </b-form-checkbox>
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </section>
      </div>
      <template #footer>
        <MainButton
          btnText="거절서 전송"
          type="submit"
          form="formMatchDenyPPopup"
          :disabled="disabledSubmit"
        />
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import UserInfoCard from "@/components/items/UserInfoCard.vue";
import matchingPopupMixins from "@/mixins/matching-popup-mixins";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";

export default {
  name: "DirectMatchDenyPPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    UserInfoCard,
    CorpInfoCard,
  },

  props: {
    isModal: Boolean,
  },
  mixins: [matchingPopupMixins],
  data() {
    return {
      disabledSubmit: false,
      form: {
        responseReason: [],
      },
    };
  },
  methods: {
    ...mapActions("directMatching", ["denyDirectMatching"]),
    onClickSubmitForm() {
      this.disabledSubmit = true;
      this.denyDirectMatching({
        responseReason: this.form.responseReason.join("<br>"),
        requestId: this.selectedDirectMatching.idx,
      })
        .then((res) => {
          this.$store.commit("matching/replaceMatchingItem", res.data);
        })
        .finally(() => {
          this.disabledSubmit = false;
          this.$store.commit("directMatching/setHideModalPopup");
        });
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form.responseReason = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-control-label {
  font-size: 18px !important;
}
</style>
